import { SvgTypesProps } from '@/shared/types/SvgTypes';

export function IconFavorites({
  fill = 'var(--sapphire-20)',
  width = 18,
  height = 18,
}: SvgTypesProps) {
  return (
    <svg width={width} height={height} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9 1L11.7688 5.83755L17 7.11146L13.48 11.3751L13.9443 17L9 14.7975L4.05573 17L4.52 11.3751L1 7.11146L6.23121 5.83755L9 1Z" stroke={fill} strokeWidth="1.5" strokeLinejoin="round"/>
    </svg>
  );
}
